export function isNullish (data) {
  if (data === null || data === undefined || data === '') return true;
  return false;
}

export function isNullOrFalse (data) {
  if (data === null || data === false) return true;
  return false;
}

export function capitalizeFirstChar (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function generateHash(length = 10) {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let hash = '';
  for (let i = 0; i < length; i++) {
    hash += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return hash;
}

export function formatarCNPJ(valor) {
  if (!valor) return '';
  const cnpj = valor.replace(/\D/g, '').slice(0, 14);
  return cnpj
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
}

export function limparTelefone(valor) {
  if (!valor) return '';
  return valor.replace(/\D/g, '').slice(0, 11);
}

// formata para: (XX) XXXX-XXXX  ou  (XX) 9XXXX-XXXX
export function formatarTelefone(valor) {
  if (!valor) return '';
  const nums = valor.replace(/\D/g, '');

  if (nums.length <= 2) {
    return nums ? `(${nums}` : '';
  }

  if (nums.length <= 6) {
    // (XX) XXXX
    return `(${nums.slice(0,2)}) ${nums.slice(2)}`;
  }

  if (nums.length <= 10) {
    // (XX) XXXX-XXXX  - 10 dígitos (fixo)
    return `(${nums.slice(0,2)}) ${nums.slice(2,6)}-${nums.slice(6)}`;
  }

  // 11 dígitos: (XX) 9XXXX-XXXX (celular)
  return `(${nums.slice(0,2)}) ${nums.slice(2,7)}-${nums.slice(7,11)}`;
}
